/* prettier-ignore */

import { Component, ElementRef, Input, ViewChild, ViewEncapsulation, input } from '@angular/core';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'cicerone-lazy-image',
  templateUrl: './lazy-image.component.html',
  styleUrls: ['./lazy-image.component.scss'],
  encapsulation: ViewEncapsulation.None
})
 
export class LazyImageComponent {
  @ViewChild("lazyImage") lazyImage!: ElementRef;
  @Input() public url!: any;
  public defaultFileImgName = input<string>('');
  @Input() public urlFallback!: string;
  @Input() public altImage?: string;

  constructor(public tools: ToolsService) {}

}